import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/colors.css';
import App from './App';
import './i18n/config';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


